module.exports = __webpack_public_path__ + "fonts/Inter-500-greek-ext52.af80f40.woff2";